import axios from 'axios';

export const apiPath = '/apigw/v1/location';

export function searchLocations(searchParams) {
  return axios.post(`${apiPath}/search`, searchParams);
}
